// extracted by mini-css-extract-plugin
export default {"footer":"_f51e0d2f"};